import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";

// Type for each field inside fieldsList
interface Field {
    fieldCode: string | null;
    fieldLabel: string | null;
    fieldDesc: string | null;
    inputField: boolean;
    fieldDataType: string | null;
    maxLength: string | null;
    validationRegEx: string | null;
    validationMessage: string | null;
    fieldExpression: string | null;
    displayOrder: number | string;
    defaultValue: string | null;
    required: boolean;
    fieldValue: string | null;
    fieldGroupCode: string | null;
}

// Type for the outer object
export interface FieldGroup {
    fieldGroupLabel: string | null;
    fieldGroupInput: boolean;
    fieldGroupOrder: number | string;
    fieldsList: Field[];
}

interface fieldDataPayload {
    [key: string]: string;
}

type logDataSystemDateState = string

interface simulationVarianceFieldValueState {
    [key: string]: string;
}

interface simulationDashboardFieldLabelList {
    trendLOVField1: string,
    trendLOVField2: string,
    kpiStaticField1: string,
    kpiStaticField2: string,
    percentageMeterField1: string,
    percentageMeterField2: string,
    percentageMeterField3: string,
    percentageMeterField4: string,
    percentageMeterField5: string,
    percentageMeterField6: string,
    percentageMeterField7: string,
    percentageMeterField8: string,
    percentageMeterVarianceField1: string,
    percentageMeterVarianceField2: string,
    percentageMeterVarianceField3: string,
    percentageMeterVarianceField4: string,
    percentageMeterVarianceField5: string,
    percentageMeterVarianceField6: string,
    percentageMeterVarianceField7: string,
    percentageMeterVarianceField8: string,
    pouField1Value: string,
    pouField2Value: string,
    pouField3Value: string,
    pouField4Value: string,
    pouField5Value: string,
    pouField6Value: string,
    pouField7Value: string,
    pouField8Value: string,
    pouField1Comments: string,
    pouField2Comments: string,
    pouField3Comments: string,
    pouField4Comments: string,
    pouField5Comments: string,
    pouField6Comments: string,
    pouField7Comments: string,
    pouField8Comments: string,
    costField1: string,
    costField2: string,
    costField3: string,
    costField4: string,
    costField5: string,
    costField6: string,
    costField7: string,
    kpiLOVField1: string,
    kpiLOVField2: string,
    kpiLOVField3: string,
    kpiLOVField4: string
    kpiLOVField5: string
    kpiLOVField6: string
    kpiLOVField7: string
    kpiLOVField8: string,
    costFieldTrend1: string,
    costFieldTrend1Label: string,
    costField1Label: string,
    costField2Label: string,
    costField3Label: string,
    costField4Label: string,
    costField5Label: string
    costField6Label: string
    costField7Label: string
}

export interface RecommendationState {
    recommendationId: string;
    recommendationMessage: string;
    acknowledged: boolean;
    status: string;
    remarks: string;
}

type simulationDashboardSingleLOVData = string

interface simulationCostTrendLOVDropdownList {
    [key: string]: string | null
}
interface simulationUpsetFieldValueState {
    [key: string]: string
}

interface genericKeyValueState {
    [key: string]: string
}

type simulationCostTrendLOVDatatype = simulationCostTrendLOVDropdownList[]
type simulationTrendLOVData = simulationCostTrendLOVDropdownList[]

export interface StateValues {
    getSimulationData: fieldDataPayload[]
    getSimulationByIdData: genericKeyValueState
    updateSimulatedData: {};
    getSimulationByIdFieldListData: FieldGroup[],
    simulationComputeFieldData: {};
    loading: boolean;
    dynamicSimulationCompanyInfo: [],
    getSimulationByIdCompanyInfoData: [],
    dynamicSimulationData: [],
    simulationRecommendationData: RecommendationState[]
    updateSimulationRecommendationData: RecommendationState[],
    simulationDashboardSingleLOVValue: simulationDashboardSingleLOVData;
    simulationDashboardFieldValueList: simulationDashboardFieldLabelList;
    simulationVarianceFieldValues: simulationVarianceFieldValueState;
    simulationDashboardRecommendationDetails: [];
    simulationCostTrendData: simulationCostTrendLOVDatatype;
    simultaionTrendLOVValues: simulationTrendLOVData;
    simulationUpsetFieldValue: simulationUpsetFieldValueState;
    addSimulationData: genericKeyValueState;
    updateSimulationCompanyInfo: genericKeyValueState;
    deleteSimulationLogData: {},
}

const initialState: StateValues = {
    simulationVarianceFieldValues: {},
    simulationCostTrendData: [],
    getSimulationByIdFieldListData: [],
    simultaionTrendLOVValues: [],
    getSimulationByIdCompanyInfoData: [],
    simulationUpsetFieldValue: {},
    getSimulationByIdData: {},
    simulationDashboardRecommendationDetails: [],
    getSimulationData: [],
    dynamicSimulationCompanyInfo: [],
    dynamicSimulationData: [],
    updateSimulatedData: {},
    simulationComputeFieldData: {},
    updateSimulationCompanyInfo: {},
    addSimulationData: {},
    simulationRecommendationData: [],
    updateSimulationRecommendationData: [],
    simulationDashboardSingleLOVValue: "",
    simulationDashboardFieldValueList: {
        trendLOVField1: "",
        trendLOVField2: "",
        kpiStaticField1: "",
        kpiStaticField2: "",
        percentageMeterField1: "",
        percentageMeterField2: "",
        percentageMeterField3: "",
        percentageMeterField4: "",
        percentageMeterField5: "",
        percentageMeterField6: "",
        percentageMeterField7: "",
        percentageMeterField8: "",
        pouField1Value: "",
        pouField2Value: "",
        pouField3Value: "",
        pouField4Value: "",
        pouField5Value: "",
        pouField6Value: "",
        pouField7Value: "",
        pouField8Value: "",
        pouField1Comments: "",
        pouField2Comments: "",
        pouField3Comments: "",
        pouField4Comments: "",
        pouField5Comments: "",
        pouField6Comments: "",
        pouField7Comments: "",
        pouField8Comments: "",
        costField1: "",
        costField2: "",
        costField3: "",
        costField4: "",
        costField5: "",
        costField6: "",
        costField7: "",
        kpiLOVField1: "",
        kpiLOVField2: "",
        kpiLOVField3: "",
        kpiLOVField4: "",
        kpiLOVField5: "",
        kpiLOVField6: "",
        kpiLOVField7: "",
        kpiLOVField8: "",
        costFieldTrend1: "",
        costFieldTrend1Label: "",
        percentageMeterVarianceField1: "",
        percentageMeterVarianceField2: "",
        percentageMeterVarianceField3: "",
        percentageMeterVarianceField4: "",
        percentageMeterVarianceField5: "",
        percentageMeterVarianceField6: "",
        percentageMeterVarianceField7: "",
        percentageMeterVarianceField8: "",
        costField1Label: "",
        costField2Label: "",
        costField3Label: "",
        costField4Label: "",
        costField5Label: "",
        costField6Label: "",
        costField7Label: ""
    },
    loading: false,
    deleteSimulationLogData: {},
};

const simulationSlice = createSlice({
    name: "simulation",
    initialState,
    reducers: {
        getSimulationCompanyInfoDetailsValue(state, action) {
            state.dynamicSimulationCompanyInfo = action.payload
        },
        getSimulationDataDetailsValue(state, action) {
            state.dynamicSimulationData = action.payload
        },
        getSimulationRecommendationDetailsValue(state, action) {
            state.simulationRecommendationData = action.payload
        },
        updateSimulationRecommendationDetailsValue(state, action) {
            state.updateSimulationRecommendationData = action.payload
        },
        getSimulationDataListDetails(state, action) {
            state.getSimulationData = action.payload
        },
        getSimulationByIdDataDetailValue(state, action) {
            state.getSimulationByIdData = action.payload
        },
        updateSimulatedFieldDataValue(state, action) {
            state.updateSimulatedData = action.payload
        },
        getSimulationComputedDataValue(state, action) {
            state.simulationComputeFieldData = action.payload
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        getSimulationDashboardFieldValue(state, action) {
            state.simulationDashboardFieldValueList = action.payload
        },
        getSimulationDashboardSingleLOVFieldValue(state, action) {
            state.simulationDashboardSingleLOVValue = action.payload
        },
        getSimulationVarianceFieldValuesData(state, action) {
            state.simulationVarianceFieldValues = action.payload
        },
        getSimulationDashboardRecommendationDetailsDate(state, action) {
            state.simulationDashboardRecommendationDetails = action.payload
        },
        getSimulationDashboardCostTrendFieldValue(state, action) {
            state.simulationCostTrendData = action.payload
        },
        getSimulationDashboardtrendLOVFieldValue(state, action) {
            state.simultaionTrendLOVValues = action.payload
        },
        getSimulationUpsetFieldValueData(state, action) {
            state.simulationUpsetFieldValue = action.payload
        },
        addSimulationDataValue(state, action) {
            state.addSimulationData = action.payload
        },
        updateSimulationCompanyInfoValueData(state, action) {
            state.updateSimulationCompanyInfo = action.payload
        },
        getSimulationByIdCompanyInfoDataValue(state, action) {
            state.getSimulationByIdCompanyInfoData = action.payload
        },
        getSimulationByIdFieldListDataValue(state, action) {
            state.getSimulationByIdFieldListData = action.payload
        },
        deleteSimulationLogDataEntry(state, action) {
            state.deleteSimulationLogData = action.payload
        }
    }
});

export default simulationSlice.reducer;

export const { setLoading } = simulationSlice.actions

// Get Simulation Recommendation List
export const getSimulationRecommendationList = (simulationId: number | string, modelCode: string) => {
    return async () => {
        const url = `/simulation/recommendation-list/${simulationId}/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationRecommendationDetailsValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Add Simulation Data 
export const addSimulation = (payload: simulationUpsetFieldValueState) => {
    return async () => {
        const url = "/simulation"
        try {
            const response = await axios.post(url, payload)
            dispatch(simulationSlice.actions.addSimulationDataValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Update Company Simulation Data 
export const updateCompanyInfoSimulation = (modelCode: string, simulationId: string, payload: genericKeyValueState) => {
    return async () => {
        const url = `/simulation/update-company-model-info/${modelCode}/${simulationId}`
        try {
            const response = await axios.put(url, payload)
            dispatch(simulationSlice.actions.updateSimulationCompanyInfoValueData(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
            return error
        }
    }
}

//Get  Simulation Dashboard Value
export const getSimulationDashboardFieldValueList = (modelCode: string, simulationId: string, kpiLOVField1: string, kpiLOVField2: string, kpiLOVField3: string, kpiLOVField4: string, kpiLOVField5: string, kpiLOVField6: string, kpiLOVField7: string, kpiLOVField8: string, varianceLOVField1: string, varianceLOVField2: string, varianceLOVField3: string, varianceLOVField4: string, varianceLOVField5: string, varianceLOVField6: string, varianceLOVField7: string, varianceLOVField8: string, pouLOVField1: string, pouLOVField2: string, pouLOVField3: string, pouLOVField4: string, pouLOVField5: string, pouLOVField6: string, pouLOVField7: string, pouLOVField8: string) => {
    return async () => {
        const url = `/simulation/dashboard/values/${modelCode}/${simulationId}?kpiLOVField1=${kpiLOVField1}&kpiLOVField2=${kpiLOVField2}&kpiLOVField3=${kpiLOVField3}&kpiLOVField4=${kpiLOVField4}&kpiLOVField5=${kpiLOVField5}&kpiLOVField6=${kpiLOVField6}&kpiLOVField7=${kpiLOVField7}&kpiLOVField8=${kpiLOVField8}&varianceLOVField1=${varianceLOVField1}&varianceLOVField2=${varianceLOVField2}&varianceLOVField3=${varianceLOVField3}&varianceLOVField4=${varianceLOVField4}&varianceLOVField5=${varianceLOVField5}&varianceLOVField6=${varianceLOVField6}&varianceLOVField7=${varianceLOVField7}&varianceLOVField8=${varianceLOVField8}&pouLOVField1=${pouLOVField1}&pouLOVField2=${pouLOVField2}&pouLOVField3=${pouLOVField3}&pouLOVField4=${pouLOVField4}&pouLOVField5=${pouLOVField5}&pouLOVField6=${pouLOVField6}&pouLOVField7=${pouLOVField7}&pouLOVField8=${pouLOVField8}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDashboardFieldValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Single LOV Simulation Dashboard Value 
export const getSimulationDashboardSingleLOVFieldValueList = (modelCode: string, fieldCode: string, simulationId: string, componentCode: string) => {
    return async () => {
        const url = `/simulation/dashboard/field-value/${modelCode}/${fieldCode}/${componentCode}/${simulationId}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDashboardSingleLOVFieldValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Simulation Dashboard Variance Field Value 
export const getSimulationVarianceFieldValue = (modelCode: string, simulationId: string, varianceCode: string) => {
    return async () => {
        const url = `/simulation/dashboard/variance-field-values/${modelCode}/${simulationId}/${varianceCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationVarianceFieldValuesData(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error))
        }
    }
}

// Get Simulation Dashboard Recommendation Details Data
export const getSimulationDashboardRecommendationDetails = (simulationId: string, modelCode
    : string) => {
    return async () => {
        const url = `/simulation/dashboard/recommendation-list/${simulationId}/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDashboardRecommendationDetailsDate(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Simulation Dashboard Cost Trend  Graph Data 
export const getSimulationDashboardCostTrendFieldValueData = (field1Code
    : string, field2Code: string, simulationId: string, modelCode: string) => {
    return async () => {
        const url = `/simulation/dashboard/field-value/last-90-days/${simulationId}/${modelCode}?field1Code=${field1Code}&field2Code=${field2Code}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDashboardCostTrendFieldValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Simualtion Trend LOV Graph Data 
export const getSimulationDashboardtrendLOVFieldValueData = (field1Code
    : string, field2Code: string, simulationId: string, modelCode: string) => {
    return async () => {
        const url = `/simulation/dashboard/field-value/last-30-days/${simulationId}/${modelCode}?field1Code=${field1Code}&field2Code=${field2Code}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDashboardtrendLOVFieldValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// GET Simualtion UPSET Field Values
export const getSimulationUpsetFieldValue = (modelCode: string, fieldCode: string, simulationId: string) => {
    return async () => {
        const url = `/simulation/dashboard/field-value-upset/${modelCode}/${fieldCode}/${simulationId}`;
        try {
            const response = await axios.get(url);
            dispatch(simulationSlice.actions.getSimulationUpsetFieldValueData(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Simulation Data List
export const getSimulationDataList = (modelCode: string) => {
    return async () => {
        const url = `/simulation/list/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDataListDetails(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Update Simulation Recommendation Data
export const updateSimulationRecommendationData = (payload: any, simulationId: number, modelCode: string) => {
    return async () => {
        const url = `/simulation/recommendation-data/${simulationId}/${modelCode}`
        try {
            const response = await axios.put(url, payload)
            dispatch(simulationSlice.actions.updateSimulationRecommendationDetailsValue(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error: any) {
            return error
        }
    }
}

// Get Simulation Log Data List
export const getSimulationDataFieldList = (modelCode: string) => {
    return async () => {
        dispatch(setLoading(true));
        const url = `/simulation/field-list/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationDataDetailsValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        } finally {
            dispatch(setLoading(false));
        }
    }
}

// Get Simulation By Id Log Data List
export const getSimulationByIdFieldListDataDetails = (modelCode: string, simulationId: string) => {
    return async () => {
        dispatch(setLoading(true));
        const url = `/simulation/field-list/${modelCode}/${simulationId}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationByIdFieldListDataValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        } finally {
            dispatch(setLoading(false));
        }
    }
}

// Get Single Simulation by Id Data
export const getSimulationByIdDataDetails = (modelCode: string, simulationId: string) => {
    return async () => {
        const url = `/simulation/${modelCode}/${simulationId}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationByIdDataDetailValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Update Simulation Log Data
export const updateSimulationLogData = (payload: fieldDataPayload, simulationId: number, modelCode: string) => {
    return async () => {
        const url = `/simulation/${simulationId}/${modelCode}`
        try {
            const response = await axios.put(url, payload)
            dispatch(simulationSlice.actions.updateSimulatedFieldDataValue(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            // dispatch(handleSnackbar(error));
            return error
        }
    }
}

// Get Simulation Computed Data
export const getSimulationComputedData = (payload: fieldDataPayload, simulationId: number, modelCode: string,) => {
    return async () => {
        const url = `/simulation/get-eval-fields-value/${simulationId}/${modelCode}`
        try {
            const response = await axios.post(url, payload)
            dispatch(simulationSlice.actions.getSimulationComputedDataValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Simulation Company Info Details
export const getSimulationCompanyInfoDetails = (modelCode: string) => {
    return async () => {
        const url = `/simulation/company-fields/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationCompanyInfoDetailsValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Simulation Company Info Details
export const getSimulationyByIdCompanyInfoDetails = (simulationId: string, modelCode: string) => {
    return async () => {
        const url = `/simulation/company-fields/${simulationId}/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(simulationSlice.actions.getSimulationByIdCompanyInfoDataValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Delete Simulation Log Entry Data
export const deleteSimulationData = (modelCode: string, simulationId: string) => {
    return async () => {
        const url = `/simulation/${modelCode}/${simulationId}`
        try {
            const response = await axios.delete(url)
            dispatch(simulationSlice.actions.deleteSimulationLogDataEntry(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}